// eslint-disable-next-line import/prefer-default-export
export const toggleSidebar = async ({ commit }) => {
  commit('toggleSidebar');
  return true;
};

export const setSidebar = async ({ commit }, value) => {
  commit('setSidebar', value);
  return true;
};
